import { render, staticRenderFns } from "./channel-item.html?vue&type=template&id=d56c08a6&scoped=true&"
import script from "./channel-item.js?vue&type=script&lang=js&"
export * from "./channel-item.js?vue&type=script&lang=js&"
import style0 from "./channel-item.scss?vue&type=style&index=0&id=d56c08a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56c08a6",
  null
  
)

export default component.exports